var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  d: "M18.215 12.925a.63.63 0 0 0-.667-.183c-2.55.85-5.358-.075-6.841-2.259-1.584-2.333-1.259-5.5.758-7.541a.628.628 0 0 0-.442-1.067C6.54 1.875 2.898 5.517 2.898 10s3.642 8.125 8.125 8.125a8.09 8.09 0 0 0 7.284-4.517.64.64 0 0 0-.092-.691zm-7.192 3.95A6.88 6.88 0 0 1 4.148 10c0-3.308 2.35-6.075 5.459-6.725-1.534 2.4-1.559 5.517.066 7.917 1.5 2.216 4.125 3.358 6.75 3.075a6.83 6.83 0 0 1-5.4 2.616z"
})));
export default SvgIconMoon;